export const FETCH_PRIVATE_SHOPS_SUCCESS = 'FETCH_PRIVATE_SHOPS_SUCCESS';
export const FETCH_PRIVATE_SHOPS_ERROR = 'FETCH_PRIVATE_SHOPS_ERROR';

export const FETCH_PUBLIC_SHOPS_SUCCESS = 'FETCH_PUBLIC_SHOPS_SUCCESS';
export const FETCH_PUBLIC_SHOPS_ERROR = 'FETCH_PUBLIC_SHOPS_ERROR';

export const FETCH_GLOBAL_SHOPS_SUCCESS = 'FETCH_GLOBAL_SHOPS_SUCCESS';
export const FETCH_GLOBAL_SHOPS_ERROR = 'FETCH_GLOBAL_SHOPS_ERROR';

export const FETCH_BRANDED_SHOPS_SUCCESS = 'FETCH_BRANDED_SHOPS_SUCCESS';
export const FETCH_BRANDED_SHOPS_ERROR = 'FETCH_BRANDED_SHOPS_ERROR';

export const SET_OPENED_SHOP_INFO = 'SET_OPENED_SHOP_INFO';
